<template>
    <div class="d-flex align-center text-no-wrap">
      <v-avatar v-if="avatar!==undefined&&user?.imageUrl" :size="avatarSize!==undefined ? avatarSize : 24" class="mr-2" >
        <img :src="user.imageUrl"/>
      </v-avatar>
      <span v-if="short===undefined" class="mr-1">{{$tools.userFullName(user,false)}}</span>
      <tooltip v-else right>              
        <span class="mr-1">{{$tools.userFullName(user,true)}}</span>
        <template v-slot:content>
          {{$tools.userFullName(user,false)}}
        </template>
      </tooltip>

      <copy-button :data="$tools.userFullName(user)" :big="bigIcon===undefined&&undefined"/>
      
      <v-btn 
          @click.stop
          :x-small="bigIcon===undefined"
          icon depressed :href="'/panel/user/'+(spec===undefined ? 'client' : 'spec')+'/'+user.id+'/'" target="_blank">
        <v-icon :small="bigIcon===undefined">mdi-open-in-new</v-icon>
      </v-btn>
    </div>
</template>
<script>

import CopyButton from "@/components/CopyButton.vue";
import Tooltip from "@/componentsV2/base/Tooltip.vue";


export default {
  components: {
    CopyButton,
    Tooltip
  },
  props: [
    'avatar',
    'avatarSize',
    'short',
    'spec',
    'user',
    'bigIcon'
  ]
}
</script>